import Factory from "@/factories/Factory.ts";
import type { Profile } from "@/types/account";

interface ProfileResource {
  firstName: string;
  lastName: string;
  email: string;
}

class ProfileFactory extends Factory<Profile, ProfileResource> {
  public fromJson(resource: ProfileResource): Profile {
    return {
      firstName: resource.firstName,
      lastName: resource.lastName,
      email: resource.email,
    };
  }
}

export { ProfileFactory, type ProfileResource };
